import { FlutterFromStrategyIcon, ReactNativeFromStrategyIcon } from '@/svgs'
import React from 'react'

function ReactNativeFromStrategy() {
   return (
      <section id="development-guide-section" className="cs-bg-theme-color-2">
         <div className="container">
            <h2 className="section_heading_title mb-3">
               From Idea to Launch:
               <br />
               Our React Native Development Process
            </h2>

            <p className="section_desc">
               12+ years of experience in React Native app development, we
               design scalable, secure, and high-performing mobile apps
               according to your business requirements. Our skilled team works
               with you to create a strategic plan, offering easy deployment and
               long-term success. Use our React Native solutions for boosting
               user experience, optimizing application performance, and staying
               competitive. Let's create excellence together!
            </p>

            <ReactNativeFromStrategyIcon />
         </div>
      </section>
   )
}

export default ReactNativeFromStrategy
